export type BudgetDecisionUser = {
  id: number;
  is_admin?: boolean;
  is_sponsor?: boolean;
};

export type BudgetApprovalContext = {
  budget_type: string;
  department_owner_id?: number | null;
  created_by: number;
};

/**
 * Mirrors api/budget/budget.v2.management.ts canUserDecideBudgetChange.
 * Note: new Global budgets are auto-approved on create; this still applies to
 * Department / System (and any leftover PENDING Global) rows in the approval UI.
 */
export function canUserDecideBudgetChange(
  user: BudgetDecisionUser,
  row: BudgetApprovalContext,
): boolean {
  if (Number(user.id) === Number(row.created_by)) {
    return false;
  }

  if (user.is_admin) {
    return true;
  }

  const budgetType = row.budget_type;

  if (budgetType === 'System') {
    const deptOwnerId = row.department_owner_id;
    if (deptOwnerId == null) {
      return false;
    }
    const requesterIsDeptOwner = Number(row.created_by) === Number(deptOwnerId);
    if (requesterIsDeptOwner) {
      return Boolean(user.is_sponsor);
    }
    return Number(user.id) === Number(deptOwnerId);
  }

  if (budgetType === 'Department' || budgetType === 'Global') {
    return Boolean(user.is_sponsor);
  }

  return false;
}
